/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = { "default": require("core-js/library/fn/reflect/apply"), __esModule: true };



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/apply.js
// module id = 1064
// module chunks = 60